import { fontGroups } from '@zoopla-eng/zds/themes';
import { FC } from 'react';
import { baseStyle } from './index.styles.css';

const numberFormatter = Intl.NumberFormat('en-GB').format;

type Props = {
    totalResults: number;
};

export const PropertyCountLabel: FC<React.PropsWithChildren<Props>> = ({
    totalResults
}) => (
    <label className={`${baseStyle} ${fontGroups.ladle}`}>
        {numberFormatter(totalResults)} propert
        {totalResults > 1 ? 'ies' : 'y'} found
    </label>
);
